export default __webpack_public_path__ + "static/media/water.82037804.png";